import { connectedReduxRedirect } from 'redux-auth-wrapper/history3/redirect';
import connectedAuthWrapper from 'redux-auth-wrapper/connectedAuthWrapper';
import { routerActions } from 'react-router-redux';
import { isAdmin } from '../../../reducers/user';
import { can } from '../../../services';
import { omit } from 'lodash';
import { ALLOWED_DASHBOARD_POSITIONS, ALLOWED_DASHBOARD_NAMES } from 'config/constants';

const userIsAuthenticated = connectedReduxRedirect({// eslint-disable-line new-cap
  authenticatedSelector: state => state.user.isAuthenticated,
  authenticatingSelector: state => state.user.isAuthenticating,
  redirectAction: routerActions.replace,
  redirectPath: '/login',
  wrapperDisplayName: 'UserIsAuthenticated',
});

const adminRedirect = newLocation => (dispatch, getState) => {
  dispatch(routerActions.replace(isAdmin(getState().user) ? '/login' : newLocation));
};

// redirect to newLocation minus the query string, expanding relative
// paths if they exist
const unauthorizedRedirect = newLocation => (dispatch, getState) => {
  let location = newLocation;
  if (newLocation.pathname.indexOf('/') !== 0) {
    const { routing: { locationBeforeTransitions: { pathname } } } = getState();
    let newPath = pathname;
    const lastIndex = pathname.lastIndexOf('/');
    if (lastIndex > 0) {
      newPath = pathname.substring(0, lastIndex);
    }
    newPath += `/${newLocation.pathname}`;
    location = { ...location, pathname: newPath };
  }
  dispatch(routerActions.replace(omit(location, 'query')));
};

const userIsAdmin = connectedReduxRedirect({// eslint-disable-line new-cap
  authenticatedSelector: state => isAdmin(state.user),
  authenticatingSelector: state => state.user.isAuthenticating,
  redirectAction: adminRedirect,
  redirectPath: '/no-access',
  wrapperDisplayName: 'UserIsAdmin',
});

const whichCan = (action, model, user) => {
  const { role = '', position = '' } = user;
  let attrs = null;
  if (model === 'bulk_projects_load') attrs = { position };
  return attrs ? can(role, action, model, attrs) : can(role, action, model);
};

const userCan = (action, model, component, options = {}) => connectedReduxRedirect({
  authenticatedSelector: state => whichCan(action, model, state.user || {}),
  authenticatingSelector: state => state.user.isAuthenticating,
  redirectAction: unauthorizedRedirect,
  redirectPath: '/no-access',
  wrapperDisplayName: 'UserCan',
  ...options,
})(component);

const userAllowedOnDashboard = ({ user }) => {
  const position = user.position;
  const userName = user.name;
  if (ALLOWED_DASHBOARD_POSITIONS.includes(position) ||
      ALLOWED_DASHBOARD_NAMES.includes(userName)) return true;
  return false;
};

const userCanViewDashboard = component => connectedReduxRedirect({
  authenticatedSelector: state => userAllowedOnDashboard(state),
  authenticatingSelector: state => state.user.isAuthenticating,
  redirectAction: unauthorizedRedirect,
  redirectPath: '/no-access',
  wrapperDisplayName: 'UserCan',
})(component);


const visibleFor = (action, model, component) => connectedAuthWrapper({
  authenticatedSelector: state => can(state.user.role, action, model),
  wrapperDisplayName: 'visibleFor',
})(component);

export { userIsAuthenticated, userIsAdmin, userCan, visibleFor, userCanViewDashboard };
export default userIsAuthenticated;



// WEBPACK FOOTER //
// ./client/app/shared/components/Auth/index.jsx